import * as hairTextures from 'constants/hairTextures';
import { MY_LIFESTYLE } from '../constants';
import * as consultationComponents from '../constants/consultationComponents';
import { LIFESTYLE } from '../constants/progressCategories';

import lifestyleType1Desktop from 'assets/images/consultation/transitionScreens/d-lifestyle_a.jpg';
import lifestyleType2Desktop from 'assets/images/consultation/transitionScreens/d-lifestyle_b.jpg';
import lifestyleType3Desktop from 'assets/images/consultation/transitionScreens/d-lifestyle_c.jpg';
import lifestyleType4Desktop from 'assets/images/consultation/transitionScreens/d-lifestyle_d.jpg';
import lifestyleType1Mobile from 'assets/images/consultation/transitionScreens/m-lifestyle_a.jpg';
import lifestyleType2Mobile from 'assets/images/consultation/transitionScreens/m-lifestyle_b.jpg';
import lifestyleType3Mobile from 'assets/images/consultation/transitionScreens/m-lifestyle_c.jpg';
import lifestyleType4Mobile from 'assets/images/consultation/transitionScreens/m-lifestyle_d.jpg';
import lifestyleType1Tablet from 'assets/images/consultation/transitionScreens/t-lifestyle_a.jpg';
import lifestyleType2Tablet from 'assets/images/consultation/transitionScreens/t-lifestyle_b.jpg';
import lifestyleType3Tablet from 'assets/images/consultation/transitionScreens/t-lifestyle_c.jpg';
import lifestyleType4Tablet from 'assets/images/consultation/transitionScreens/t-lifestyle_d.jpg';

const consultationBackgroundImages = {
  // Lifestyle background dynamic based on hair texture
  lifestyleType1: {
    desktop: lifestyleType1Desktop,
    tablet: lifestyleType1Tablet,
    mobile: lifestyleType1Mobile,
  },
  lifestyleType2: {
    desktop: lifestyleType2Desktop,
    tablet: lifestyleType2Tablet,
    mobile: lifestyleType2Mobile,
  },
  lifestyleType3: {
    desktop: lifestyleType3Desktop,
    tablet: lifestyleType3Tablet,
    mobile: lifestyleType3Mobile,
  },
  lifestyleType4: {
    desktop: lifestyleType4Desktop,
    tablet: lifestyleType4Tablet,
    mobile: lifestyleType4Mobile,
  },
};

const myLifestyleTransitionScreen = {
  name: 'intro-lifestyle',
  category: MY_LIFESTYLE,
  progressCategory: LIFESTYLE,
  route: `/consultation/haircare/${MY_LIFESTYLE}/introduction`,
  title: 'Section 3',
  subtitle: 'How you live',
  shouldBeIncluded: () => true,
  Component: consultationComponents.Transition,
  skipSave: true,
  body: 'Your hair lives with you day-in and day-out, and is affected by your actual environment and routine. Be honest here, because your hair never lies.',
  image: ({ hairTexture }) => {
    switch (hairTexture) {
      case hairTextures.ONE:
        return consultationBackgroundImages.lifestyleType1;
      case hairTextures.WAVY:
        return consultationBackgroundImages.lifestyleType2;
      case hairTextures.DEPRECATED_CURLY:
      case hairTextures.THREE_A:
      case hairTextures.THREE_B:
      case hairTextures.THREE_C:
        return consultationBackgroundImages.lifestyleType3;
      case hairTextures.VERY_CURLY:
      case hairTextures.FRIZZY:
      case hairTextures.ZIGZAG:
        return consultationBackgroundImages.lifestyleType4;
      default:
        return consultationBackgroundImages.lifestyleType3;
    }
  },
};

export default myLifestyleTransitionScreen;
